document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-yp2]').forEach(function (root) {
    var image = root.querySelector('[data-yp2-image]');
    var data = {
      gyms: {
        title: 'Turn recovery into a service your members value.',
        copy: 'Add a premium recovery experience without changing the flow of your facility. We help you choose the right commercial setup, prepare your launch, and equip your team to introduce it confidently.',
        points: ['Commercial-ready device recommendations', 'Launch guidance and approved marketing assets', 'Partner pricing and responsive support'],
        src: image.dataset.gymsSrc,
        alt: 'Fully illuminated commercial red light therapy panel in a performance gym'
      },
      spas: {
        title: 'Create a premium light-therapy experience.',
        copy: 'Build a thoughtful service around your space, clientele, and operating model—with equipment guidance and partner support from first conversation through launch.',
        points: ['Solutions matched to room size and workflow', 'Education resources for your staff', 'Creative assets for a polished launch'],
        src: image.dataset.spasSrc,
        alt: 'Fully illuminated commercial red light therapy panel in a spa treatment room'
      },
      hotels: {
        title: 'Add a distinctive wellness amenity.',
        copy: 'Give guests a memorable recovery option that complements modern wellness programming while keeping implementation clear for your operations team.',
        points: ['Space-planning conversations', 'Guest-friendly education materials', 'Ongoing commercial partner support'],
        src: image.dataset.hotelsSrc,
        alt: 'Fully illuminated commercial red light therapy panel in a luxury hotel wellness suite'
      },
      retail: {
        title: 'Bring Yamuri to the customers you already serve.',
        copy: 'Tell us about your market, channels, and customer base. Qualified partners receive a tailored commercial conversation—not a one-size-fits-all offer.',
        points: ['Clear qualification and onboarding', 'Approved product and campaign assets', 'Partner terms aligned to your channel'],
        src: image.dataset.retailSrc,
        alt: 'Fully illuminated commercial red light therapy panel in a wellness retail showroom'
      }
    };

    Object.keys(data).forEach(function (key) {
      var preload = new Image();
      preload.src = data[key].src;
    });

    root.querySelectorAll('[data-yp2-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var item = data[tab.dataset.yp2Tab];
        root.querySelectorAll('[data-yp2-tab]').forEach(function (candidate) {
          candidate.setAttribute('aria-selected', String(candidate === tab));
        });
        root.querySelector('[data-yp2-title]').textContent = item.title;
        root.querySelector('[data-yp2-copy]').textContent = item.copy;
        root.querySelector('[data-yp2-points]').innerHTML = item.points.map(function (point) {
          return '<li>' + point + '</li>';
        }).join('');
        image.src = item.src;
        image.alt = item.alt;
      });
    });
  });
});
